<template>
	<div class="header-title-container title-font"
		tabindex="0"
		role="title"
		:aria-label="`dialog title: ${useTitle}`">
		{{ useTitle }}
	</div>
</template>

<script>
	import headerMixin from '@Mixin/headerMixin';
	export default {
		mixins: [headerMixin],
		props: {
			title: null,
		},
		computed: {
			useTitle() {
				const title = this.title || this._headerTitle;
				return title;
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '@style-vars';
	@import 'common-fonts';
	@include mobile {
		.header-title-container {
			display: flex;
			align-items: center;
			height: 100%;
			text-align: center;
		}
	}
	@include desktop {}
	@include tablet {}
</style>


// WEBPACK FOOTER //
// src/components/header/NavigationItems/HeaderTitle.vue